export interface Pet {
  id: string
  name: string
  species: string
  breed: string
  age: string
  birthDate: string
  medal: string
  validUntil: string
  microchip: string
  owner: string
  photo: string
  licenseValid: boolean
}

export interface PetReminder {
  id: string
  label: string
  date: string
  source: 'citoyen' | 'clinique' | 'ville'
}

export interface PetTodo {
  id: string
  title: string
  detail: string
  cta: string
}

export interface Sighting {
  time: string
  label: string
  place: string
}

export const pets: Pet[] = [
  {
    id: 'milo',
    name: 'Milo',
    species: 'Dog',
    breed: 'Golden Retriever',
    age: '4 years old',
    birthDate: 'March 14, 2022',
    medal: 'BON-28421',
    validUntil: 'December 31, 2027',
    microchip: '•••• 4821',
    owner: 'Bryon Mickelson',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/8e5c2f54-519f-4dfa-8746-74e3f7ebc1a3.jpg',
    licenseValid: true,
  },
  {
    id: 'nala',
    name: 'Nala',
    species: 'Cat',
    breed: 'Domestic shorthair',
    age: '2 years old',
    birthDate: 'June 2, 2024',
    medal: 'BON-30188',
    validUntil: 'December 31, 2026',
    microchip: '•••• 7734',
    owner: 'Bryon Mickelson',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/c60bfb8d-350d-41dd-9813-b9aca392035b.jpg',
    licenseValid: true,
  },
]

export const petTodos: Record<string, PetTodo[]> = {
  milo: [
    {
      id: 'vaccin',
      title: 'Vaccination reminder',
      detail: 'Vaccination due October 14, 2026.',
      cta: 'View reminder',
    },
  ],
  nala: [
    {
      id: 'medaille',
      title: 'Licence up for renewal',
      detail: 'Nala’s licence expires December 31.',
      cta: 'Renew',
    },
  ],
}

export const petReminders: Record<string, PetReminder[]> = {
  milo: [
    { id: 'vaccin', label: 'Vaccination', date: 'October 14, 2026', source: 'clinique' },
    { id: 'licence', label: 'Licence renewal', date: 'December 1, 2027', source: 'ville' },
    { id: 'micropuce', label: 'Confirm microchip details', date: 'To be scheduled', source: 'citoyen' },
  ],
  nala: [
    { id: 'licence', label: 'Licence renewal', date: 'December 1, 2026', source: 'ville' },
    { id: 'vermifuge', label: 'Deworming', date: 'November 5, 2026', source: 'citoyen' },
  ],
}

export const sourceLabels: Record<PetReminder['source'], string> = {
  citoyen: 'Reminder you added',
  clinique: 'Shared by Vet&Co',
  ville: 'Town requirement',
}

export const ruleQuestions = [
  'Can I walk Milo off leash in the park?',
  'How many pets can I have?',
  'Do cats need a licence too?',
  'What do I need to get a pet licence?',
]

export const ruleAnswers: Record<string, string> = {
  'Can I walk Milo off leash in the park?':
    'Dogs must be leashed on public property, with a leash no longer than two metres, except in the Town’s designated off-leash areas.',
  'How many pets can I have?':
    'A maximum of three pets per household, of which no more than two may be dogs.',
  'Do cats need a licence too?':
    'Yes. Every cat and dog over three months old must wear a valid Town licence.',
  'What do I need to get a pet licence?':
    'Proof of residency and, if applicable, the microchip number. Your profile details are already on file.',
}

export const atnaPetQuestions = [
  'Is Milo’s licence still valid?',
  'When do I renew his licence?',
  'How do I report Milo missing?',
  'When is his next reminder?',
]

export const sightings: Sighting[] = [
  { time: '3:20 p.m.', label: 'Last known location', place: 'Lakeshore Drive Park' },
  { time: '3:47 p.m.', label: 'Resident sighting', place: '46 Street' },
  { time: '4:05 p.m.', label: 'Resident sighting', place: 'Near the Seniors Drop-In Centre' },
]
